




























import { Component, Vue, Prop } from 'vue-property-decorator'

import Customer from '@/models/customer'
import Passenger from '@/models/passenger'
import User from '@/models/user'

@Component
export default class RoundAvatar extends Vue {
  @Prop() person!: Passenger | Customer | User
  @Prop() size!: string
  @Prop() iconClass!: string
  @Prop({ default: false }) withBorder!: boolean

  imageLoadError = false

  get personInitials(): string | null {
    if (!this.person) {
      return null
    }

    const firstNameChar = this.person.firstName ? this.person.firstName[0] : ''
    const lastNameChar = this.person.lastName ? this.person.lastName[0] : ''

    return `${firstNameChar}${lastNameChar}`.trim()
  }

  get avatarUrl(): string | undefined {
    return this.person ? this.person.thumbAvatarUrl || undefined : undefined
  }

  get initialsDisplayed(): boolean {
    return !this.avatarUrl || this.imageLoadError
  }

  get iconDisplayed(): boolean {
    const { iconClass, initialsDisplayed, personInitials, avatarUrl } = this

    return !!iconClass || (initialsDisplayed && !personInitials && !avatarUrl)
  }

  get iconClassWithDefault(): string {
    return this.iconClass ? this.iconClass : 'sc-icon-person'
  }

  registerImageLoadError() {
    this.imageLoadError = true
  }
}
